import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ArrowBack } from '@mui/icons-material';
import { ProviderActivationEventName } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useProviderActivationEvents } from '@uplift/queries';
import { Button, ContextualNavigationLayout, ProviderLayout, ScrollableView } from '@uplift/ui-v2';
import { useHistory } from 'react-router';
import { hasEvent } from '../../onboarding-dashboard/helpers';

export type ProfileLayoutProps = {
  children: React.ReactNode;
  isOnboarding: boolean;
};

export const ProfileLayout: React.FC<ProfileLayoutProps> = props => {
  const history = useHistory();
  const { classes } = useProfileLayoutStyles();
  const me = useCurrentuser();
  const { data: events } = useProviderActivationEvents(me?.id);
  const isProfileSubmittedForReview = hasEvent(events, ProviderActivationEventName.matchingProfileSubmitted);

  if (props.isOnboarding && !isProfileSubmittedForReview) {
    return (
      <ContextualNavigationLayout
        headerProps={{
          leftButton: <Button startIcon={<ArrowBack />} onClick={() => history.goBack()}>Back</Button>,
          centerBlock: <Typography variant="h6" className={classes.centerBlockHeader}>Create Your Matching Profile</Typography>
        }}
      >
        <ScrollableView>
          {props.children}
        </ScrollableView>
      </ContextualNavigationLayout>
    );
  }

  return <ProviderLayout bodyScroll={false}>{props.children}</ProviderLayout>;
};

const useProfileLayoutStyles = makeStyles({ name: 'ProfileLayout' })(theme => ({
  centerBlockHeader: {
    color: theme.palette.darkSlate.main,
    textAlign: 'center',
  },
}));
